<template>
    <div class="mlogin">
        <div class="login-component" :style="{left:login_component_left}">
            <p style="color: #6B99F0; font-size: 30px; margin-top: 50px;">儒悘网管理后台</p>
            <el-form :model="ruleForm" ref="ruleForm">

                <el-form-item prop="account">
                    <el-input class="login-input" v-input-theme placeholder="请输入账号" @input="accountCheck" size="medium"
                              v-model="ruleForm.account" ref="account">
                        <i slot="prefix" class="el-icon-user"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input class="login-input" v-model="ruleForm.password" placeholder="请输入密码"
                              v-input-theme
                              size="medium"
                              :type="typeSwitch">
                        <i slot="prefix" class="el-icon-lock"></i>
                        <i :class="['el-icon-view', { 'eye-active': eyeActive }]"
                           slot="suffix"
                           @mousedown="handleIconDown"
                           @mouseup="handleIconUp"
                        ></i>
                    </el-input>
                </el-form-item>

                <div style="text-align: left;width: 90%;margin: 0 auto">
                    <el-checkbox
                        v-model="pwd_checked"
                        label="记住登录状态"
                        name="type"
                    ></el-checkbox>
                </div>
                <el-form-item class="login-btn">
                    <el-button type="primary" native-type="submit"  @click.prevent="handleLogin">登录</el-button>
                </el-form-item>
                <div style="text-align: right;width: 90%;margin: 0 auto;margin-bottom: 20px;" v-if="env_model === 'production'">
                    <a :href="download_file" class="download_file"> PC端下载 </a>
                    <el-dropdown class="download_file download_mobile" trigger="click">
                        <el-button type="primary">
                            移动端下载
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-image style="width: 100px;height: 100px;margin: auto 10px;" :src="download_mobile"></el-image>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import {assembleRoutes} from "@/utils/assembly";
import Env from "@/api/env";
import CryptoJS from "crypto-js";
import {MessageBox} from "element-ui";
import {upgradeForAndroid} from "@/utils/permission";
import {check} from "@/utils/checkData";
import env from "@/api/env";
import {isMobile} from "@/api/order";

export default {
    data() {
        return {
            env_model: '',
            download_file: "https://www.ryiw.vip/frontweb/ryiw-admin.exe",
            download_mobile: require('@/assets/admin_apk.png'),
            typeSwitch: "password",
            eyeActive: false,
            // 表单
            ruleForm: {
                account: "",
                password: "",
            },
            is_submit: false,
            pwd_checked: false,
            error_info: '',
            is_product: false,
            version_num: '0.0',
            new_version_num: '0.0',
            login_component_left: 0,
        };
    },
    beforeCreate() {
        if (isMobile()) {
            if (Env.MODE_ENV && Env.MODE_ENV === 'admin') {
                try {
                    cordova.getAppVersion.getVersionNumber(version => {
                        this.version_num = version
                        this.adminAppUpdate(version)
                    });
                }catch (e) {
                    // this.$message({
                    //     type: "info",
                    //     message: `当前应用版本号: ${e}`,
                    //     duration: 3000
                    // })

                }
            }
        }
    },
    mounted() {
        this.handleResize()
        window.addEventListener('resize', this.handleResize);
        this.$refs.account.focus();
        let _that = this
        this.env_model = process.env.NODE_ENV
        if (process.env.NODE_ENV === 'production') {
            let url = window.location.href
            if (document.location.protocol == 'http:' && url.indexOf('192') < 0) {
                url = url.replace('http:', 'https:')
                window.location.href = url
            }
        }
        setTimeout(()=>{
            if (window.localStorage.getItem('pwd_checked') != null) {
                let pwd_check = window.localStorage.getItem('pwd_checked'); // 1,2
                let is_logout = window.localStorage.getItem('is_logout'); // 1,2
                if (pwd_check == '1') {
                    this.pwd_checked = true;
                }
                // 重新拉取路由
                if (pwd_check == '1' && is_logout == '2') {
                    assembleRoutes(() => {
                        this.$router.replace(this.$store.getters.homePage);
                        this.is_submit = false;
                    });
                } else {
                    this.ruleForm.account =  this.aesDecrypt(window.localStorage.getItem('login_account'), 'ryw_login');
                    if (pwd_check == '1') {
                        this.ruleForm.password = this.aesDecrypt(window.localStorage.getItem('login_pwd'), 'ryw_login');
                    }
                }
            }

        }, 500)
    },
    directives: {
        "input-theme": {
            bind(el) {
                el.querySelector("input").style.background = "#3e5368";
                el.querySelector("input").style.color = "#fff";
            }
        }
    },
    methods: {
        handleResize() {
            if (window.innerWidth > 500) {
                this.login_component_left = 'calc((100vw - 500px)/2)'
            } else {
                this.login_component_left = 0
            }
        },
        accountCheck(e) {
            var reg = /[\u4e00-\u9fa5]/g;
            var reg2 = /[^A-Za-z0-9]{1,}/g;
            if (reg.test(e) || reg2.test(e)) {
                this.ruleForm.account = e.replace(reg, '')
                this.ruleForm.account = e.replace(reg2, '')
                // this.$message.error("账号不能为中文");
                return;
            }
        },
        codeCheck(e) {
            var reg = /[^A-Za-z2-8]{1,}/g;
            if (reg.test(e)) {
                this.$message.error("请输入正确的验证码");
                return;
            }
        },
        // 登录
        handleLogin() {
            if (this.is_submit) {
                return;
            }
            this.is_submit = true;
            if (!this.ruleForm.account || !this.ruleForm.password) {
                this.$message.error("账号和密码不能为空");
                this.is_submit = false;
                return;
            }


            this.$store
                .dispatch("login", {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'login',
                    params: {
                        account: this.ruleForm.account.trim().replace(/\b/g, ""),
                        password: this.$md5(this.ruleForm.password.trim().replace(/\b/g, "")),
                    }
                })

                .then(res => {
                    window.localStorage.setItem('login_account', this.aesEncrypt(this.ruleForm.account, 'ryw_login'));
                    if (this.pwd_checked) {
                        window.localStorage.setItem('pwd_checked', '1');
                        window.localStorage.setItem('login_pwd', this.aesEncrypt(this.ruleForm.password, 'ryw_login'));
                    } else {
                        window.localStorage.setItem('pwd_checked', '2');
                    }
                    window.localStorage.setItem('is_logout', '2');
                    // return;
                    // 重新拉取路由
                    assembleRoutes(() => {

                        this.$router.replace(this.$store.getters.homePage);
                        this.ruleForm.verifycode = '';
                        this.is_submit = false;
                    });


                }).catch(e => {
                this.ruleForm.verifycode = '';
                this.is_submit = false;
                return;
            }).finally(()=>{
                this.is_submit = false;
                this.ruleForm.verifycode = '';
            });

        },
        start() {
            this.$store
                .dispatch("login", {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'login',
                    params: {
                        account: '',
                        password: ''
                    }
                })
                .then(res => {

                }).catch(e => {

                return;
            });
        },
        // 点击密码图表的切换
        handleIconDown() {
            this.typeSwitch = "text";
            this.eyeActive = true;
        },
        handleIconUp() {
            this.typeSwitch = "password";
            this.eyeActive = false;
        },
        //加密
        aesEncrypt(plaintext, key) {
            return CryptoJS.AES.encrypt(plaintext, key).toString();
        },
        //解密
        aesDecrypt(ciphertext, key) {
            let bytes = CryptoJS.AES.decrypt(ciphertext, key);
            return bytes.toString(CryptoJS.enc.Utf8);
        },
        adminAppUpdate(localVersion){
            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'getAdminVersion',
                params: {
                    version_num: localVersion,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let new_version = res.data.data.admin_version || 0
                this.new_version_num = new_version
                if (new_version.toString() > localVersion.toString() ) {
                    this.$confirm(`<b style="font-size: 16px;">发现新版本, 是否更新</b>`, '', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '更新',
                        cancelButtonText: '取消',
                    }).then(() => {
                        window.location.href = 'https://www.ryiw.vip/frontweb/ryiw-admin.apk'
                    }).catch(()=>{});
                }

            });

        }
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";
#app{
    min-width: 100vw;
}
.mlogin {
    width: 100%;
    height: 100%;
    background: #2d3a4b;
    position: relative;

    .login-component {
        position: absolute;
        //left: 50%;
        top: 50%;
        margin-top: -220px;
        background: white;
        max-width: 500px;
        width: 100vw;
        //margin-left: -140px;
        & > img {
            width: 150px;
        }
    }

    .login-input,.code-input {
        width: 90%;
        margin: 20px auto 0 auto;
        height: 32px;

        .el-input {
            height: 32px;
        }
    }

    .login-btn {
        width: 90%;
        margin: 20px auto 25px auto;

        .el-button {
            width: 100%;
            height: 36px;
            line-height: 6px;
            font-size: 14px;
        }
    }

    h3 {
        text-transform: uppercase;
        text-align: left;
    }

    input::-webkit-input-placeholder {
        color: white;
        font-size: 14px;
    }

    input {
        border-color: rgba(255, 255, 255, 0.1);
        font-size: 14px;
    }

    input:focus {
        border-color: $dominantHue;
        border-width: 2px;
    }

    .el-icon-user,
    .el-icon-lock {
        margin: 11px 0 0 5px;
    }

    .el-icon-view {
        margin: 7px 10px 0 0;
        font-size: 20px;
        cursor: pointer;
    }

    .eye-active {
        color: $dominantHue;
    }
    .download_file{
        //text-decoration-line: none;
        font-size: 14px;
        color: #019ae8;
        margin-left:15px;
        margin-right: 0;
    }
    .download_mobile {
        button{
            display: inline !important;
            background: none !important;
            font-size: 14px;
            color: #019ae8;
            border:none;
            font-weight: bold;
            text-decoration: underline;
            padding-right: 0;
        }

    }
}
</style>



